;jQuery(function ($) {

    let registered  = false;
    let initialized = false;

    let queue = [];

    $('.google-maps').each(( i, el ) => {

        let $el  = $(el);
        let data = $el.data();

        if ( ! ( data.lat && data.lng ) ) {
            console.error('Missing google map latitude and/or longitude!');
            return
        }

        if ( !initialized ) {
            queue.push($el);
            if ( !registered ) { register(); }
            return;
        }

        resolve($el, data);
    });

    function register () {

        window.__mapCallback = function () {

            this.initialized = true;

            $(queue).each((i, $el) => {
                resolve($el);
            });
        };

        let key    = window.Testlab.config.googleMaps.apiKey;
        let locale = ( $('html').attr('lang') || 'en_GB' ).split('_');

        let src = 'https://maps.googleapis.com/maps/api/js'
                + '?key=' + key
                + '&callback=__mapCallback'
                + '&language=' + locale[0]
                + '&region=' + locale[1];

        let script = $('<script></script>');
        script.attr( 'src', src );
        script.attr( 'async', true );
        script.attr( 'defer', true );
        $('head').append(script);

        registered = true;
    };

    function resolve($el) {
        let data = $el.data();

        var center = {
            lat: data.lat,
            lng: data.lng
        };

        var map = new google.maps.Map( $el.get(0), {
            zoom   : data.zoom || 12,
            center : center
        });

        var marker = new google.maps.Marker({
            position : center,
            map      : map
        });
    };

});